import styles from './FJEmptyUploadButton.module.less';
import UploadCircleIcon from '../../assets/svg/upload-circle.svg?react';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJUploadBorderIcon from '../../assets/svg/upload-border-normal.svg?react';
import FJUploadBorderHoverIcon from '../../assets/svg/gradient-border.svg?react';
import classNames from 'classnames';

class FJEmptyUploadButtonClass {
    constructor(props) {
        this._text = props.text || '';
    }

    _renderBorder = () => {
        return (
            <div className={styles.upload_border_box}>
                <FJUploadBorderIcon className={styles.upload_border} />
                <FJUploadBorderHoverIcon className={styles.upload_border_hover} />
            </div>
        );
    };

    _renderIcon = () => {
        return <UploadCircleIcon className={styles.upload_icon} />;
    };

    _renderText = () => {
        return (
            <div
                className={styles.upload_text}
                dangerouslySetInnerHTML={{
                    __html: FJLocalStore._(this._text),
                }}
            />
        );
    };

    render = (options = {}) => {
        const { className = '', isDraggingFile, onClick } = options;
        return (
            <div
                className={classNames(styles.empty_box, className, isDraggingFile && styles.dragging)}
                onClick={onClick}
            >
                {this._renderIcon()}
                {this._renderText()}
                {this._renderBorder()}
            </div>
        );
    };
}

export default FJEmptyUploadButtonClass;
